export class MonitoringConstants {

	static readonly CHART_RAM_JAVA = 'java';
	static readonly CHART_RAM_SYSTEM = 'ram';
	static readonly DATE = 'date';
	static readonly NAME = 'name';
	static readonly PRIORITY = 'priority';
	static readonly RESOURCE = 'resource';
	static readonly STATUS = 'status';
	static readonly REFRESH_DELAY = 60000;

	// Pie Chart
	static readonly BOTTOM_10 = '10%';
	static readonly BOTTOM_20 = '20%';
	static readonly BOTTOM_30 = '30%';
	static readonly FREE = 'Free';
	static readonly LEFT_20 = '20%';
	static readonly RIGHT_20 = '20%';
	static readonly TYPE_TEXT = 'text';
	static readonly USED = 'Used';
}